import logWarningInDev from '../helpers/logWarningInDev';
import { useEffect } from 'react';
export default function useWarningInDev(condition, msg) {
    useEffect(() => {
        if (process.env.NODE_ENV !== 'production') {
            logWarningInDev(condition, msg);
        }
    }, [condition, msg]);
}
//# sourceMappingURL=useWarningInDev.js.map